import React from "react";
import { useHistory } from "react-router";
import LegalSegment from "../pages/legal-segments/LegalSegment.js";
import storeContactMeMessage from "../../services/data-store/contact-me.js";
import { Helmet } from "react-helmet";
import Popup from "./Popup.js";
import Styles from "./ContactMeCard.module.css";
import { Row, Col } from "react-bootstrap";
import Checkbox from "@material-ui/core/Checkbox";
import ActionButton from "./ActionButton.js";
import InputFiled from "./InputField.js";
import InputTextArea from "./InputTextArea.js";
import InputCheckbox from "./InputCheckbox.js";

import {
  validateName,
  validateEmail,
  validateBasicString,
  validateBasicTextAreaString,
  validateTermsCheck,
} from "../../services/inputValidation.js";
import { propTypes } from "react-bootstrap/esm/Image";

function ContactMeCard(props) {
  var history = useHistory();
  React.useEffect(() => {
    checkFormValidity();
  }, [
    firstNameError,
    lastNameError,
    emailError,
    subjectError,
    occupationError,
    messageError,
  ]); //Refreshes the screen
  //Text Fields State
  //FistName State
  var [firstName, setFirstName] = React.useState(null);
  var [firstNameError, setFirstNameError] = React.useState(null);

  //Last Name State
  var [lastName, setLastName] = React.useState(null);
  var [lastNameError, setLastNameError] = React.useState(null);

  //Email State
  var [email, setEmail] = React.useState(null);
  var [emailError, setEmailError] = React.useState(null);

  //Subject State
  var [subject, setSubject] = React.useState(null);
  var [subjectError, setSubjectError] = React.useState(null);

  //Occupation State
  var [occupation, setOccupation] = React.useState(null);
  var [occupationError, setOccupationError] = React.useState(null);

  //Message State
  var [message, setMessage] = React.useState(null);
  var [messageError, setMessageError] = React.useState(null);

  //Agree  State
  var [termsCheck, setTermsCheck] = React.useState(false);
  var [termsCheckError, setTermsCheckError] = React.useState(null);

  //State Trigger to Show Terms of Agreement
  var [showTerms, setShowTerms] = React.useState(false);

  //Full Form Validity
  var [fullFormValidity, setFullFormValidity] = React.useState(false);

  //Form Send State Validity
  var [sendState, setSendState] = React.useState({ label: "Send" });
  var [sendLoad, setSendLoad] = React.useState(false);

  async function checkFormFieldsValidity() {
    //Check FirstName
    var validateFirstNameResult = await validateName(firstName);
    await setFirstNameError(validateFirstNameResult);

    //Check LastName
    var validateLastNameResult = await validateName(lastName);
    await setLastNameError(validateLastNameResult);

    //Check Email
    var validateEmailResult = await validateEmail(email);
    await setEmailError(validateEmailResult);

    //Check Subject
    var validateSubjectResult = await validateBasicString(subject);
    await setSubjectError(validateSubjectResult);

    //Check Occupation
    var validateOccupationResult = await validateBasicString(occupation);
    await setOccupationError(validateOccupationResult);

    //Check Message
    var validateMessageResult = await validateBasicTextAreaString(message);
    await setMessageError(validateMessageResult);

    var validateTermsCheckResult = await validateTermsCheck(termsCheck);
    await setTermsCheckError(validateTermsCheckResult);

    return { ok: true };
  }

  //CheckFormValidity
  function checkFormValidity() {
    if (
      firstNameError &&
      lastNameError &&
      emailError &&
      subjectError &&
      occupationError &&
      messageError &&
      termsCheckError
    ) {
      if (
        firstNameError.ok &&
        lastNameError.ok &&
        emailError.ok &&
        subjectError.ok &&
        occupationError.ok &&
        messageError.ok &&
        termsCheckError.ok
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  //Send Function
  async function sendMessage(message) {
    setSendLoad(true);
    //Store Data
    var storeDataResult = await storeContactMeMessage(message);

    setTimeout(() => {
      if (storeDataResult.ok === true) {
        setSendLoad(false);
        setSendState({ label: "Sent" });
        setTimeout(() => {
          history.goBack();
        }, 2000);
      } else {
        setSendLoad(false);
        setSendState({ label: "Failed" });
        setTimeout(() => {
          setSendState({ label: "Send" });
        }, 1000);
      }
    }, 1000);
  }

  return (
    <>
      <Helmet>
        <title>Contact Me - Matamando Kalilani</title>
        <meta name="description" content="Get in contact with Matamando Kalilani." />
        <link rel="canonical" href="https://mata.codes/contact-me" />
        <meta name="robots" content="index, follow" />
      </Helmet>{" "}
      <Popup
        show={props.show}
        toggleShowContactCard={props.toggleShowContactCard}
      >
        <div className={Styles.EntireCard}>
          {!showTerms ? (
            <>
              <Row className={Styles.CardHeader}>
                <Col style={{ padding: "0px" }}>
                  <h1 className={Styles.HeaderText}>Write me an email...</h1>{" "}
                  <div className={Styles.Divider}></div>
                </Col>
              </Row>
              <Row className={Styles.FirstTextFields}>
                <InputFiled
                  label="First Name"
                  value={firstName}
                  onChange={async (value) => {
                    setFirstName(value);
                    var validateNameResult = await validateName(value);
                    setFirstNameError(validateNameResult);
                  }}
                  error={firstNameError}
                />
                <InputFiled
                  label="Last Name"
                  value={lastName}
                  onChange={async (value) => {
                    setLastName(value);
                    var validateNameResult = await validateName(value);
                    setLastNameError(validateNameResult);
                  }}
                  error={lastNameError}
                />
                <InputFiled
                  label="Email"
                  value={email}
                  onChange={async (value) => {
                    setEmail(value);
                    var validateEmailResult = await validateEmail(value);
                    setEmailError(validateEmailResult);
                  }}
                  error={emailError}
                />
              </Row>
              <Row className={Styles.SecondTextFields}>
                <InputFiled
                  label="Subject"
                  value={subject}
                  onChange={async (value) => {
                    setSubject(value);
                    var validateSubjectResult = await validateBasicString(
                      value
                    );
                    setSubjectError(validateSubjectResult);
                  }}
                  error={subjectError}
                />
                <InputFiled
                  label="Occupation"
                  value={occupation}
                  onChange={async (value) => {
                    setOccupation(value);
                    var validateOccupationResult = await validateBasicString(
                      value
                    );
                    setOccupationError(validateOccupationResult);
                  }}
                  error={occupationError}
                />
              </Row>
              <Row className={Styles.ThirdTextFields}>
                <InputTextArea
                  label="Message"
                  value={message}
                  onChange={async (value) => {
                    setMessage(value);
                    var validateMessageResult =
                      await validateBasicTextAreaString(value);
                    setMessageError(validateMessageResult);
                  }}
                  error={messageError}
                  wrapperStyle={{ width: "auto", height: "120px" }}
                  entireComponentStyle={{ width: "100%" }}
                />
              </Row>
              <Row className={Styles.CheckboxFileds}>
                <Col
                  style={{
                    display: "inline-flex",
                    alignContent: "center",
                    justifyContent: "center",
                  }}
                >
                  <InputCheckbox
                    checked={termsCheck}
                    onClick={async (state) => {
                      setTermsCheck(state);
                      var validateTermsCheckResult = await validateTermsCheck(
                        state
                      );
                      setTermsCheckError(validateTermsCheckResult);
                    }}
                    style={{ margin: "auto 0px" }}
                  />

                  <p className={Styles.CheckBoxText}>
                    I agree to the{" "}
                    <span
                      className={Styles.TOAText}
                      onClick={() => {
                        setShowTerms(true);
                      }}
                    >
                      Terms and Conditions
                    </span>{" "}
                    and{" "}
                    <span
                      className={Styles.TOAText}
                      onClick={() => {
                        setShowTerms(true);
                      }}
                    >
                      Privacy Policy
                    </span>
                    .
                  </p>
                  {termsCheckError &&
                    (!termsCheckError.ok ? (
                      <p className={Styles.CheckFieldError}>
                        {termsCheckError.message}
                      </p>
                    ) : (
                      ""
                    ))}
                </Col>
              </Row>
              <Row className={Styles.SendButtonField}>
                {sendLoad ? (
                  <ActionButton
                    label="Sending"
                    icon="sending"
                    styles={{
                      backgroundColor: "#ECFFF7",
                      borderColor: "#005651",
                      color: "#005651",
                      borderStyle: "solid",
                      borderWidth: "2px",
                      marginLeft: "auto",
                      width: "inherit",
                    }}
                    iconStyles={{
                      fontSize: "20px",
                      marginLeft: "5px",
                    }}
                    onClick={async () => {}}
                  />
                ) : (
                  <ActionButton
                    label={sendState.label}
                    icon={
                      sendState.label === "Sent"
                        ? "done"
                        : sendState.label === "Failed"
                        ? "error"
                        : "send"
                    }
                    styles={{
                      backgroundColor:
                        sendState.label === "Sent"
                          ? "#ECFFF7"
                          : sendState.label === "Failed"
                          ? "#FFEFEF"
                          : "#F1F8FF",
                      borderColor:
                        sendState.label === "Sent"
                          ? "#005651"
                          : sendState.label === "Failed"
                          ? "#C70125"
                          : "#065FAA",
                      color:
                        sendState.label === "Sent"
                          ? "#005651"
                          : sendState.label === "Failed"
                          ? "#C70125"
                          : "#065FAA",
                      borderStyle: "solid",
                      borderWidth: "2px",
                      marginLeft: "auto",
                      width: "inherit",
                    }}
                    iconStyles={{
                      fontSize: "20px",
                      marginLeft: "5px",
                    }}
                    onClick={async () => {
                      await checkFormFieldsValidity();

                      //Check Entire Form Validity
                      var flag = checkFormValidity();

                      if (flag) {
                        console.log("Form Sent");
                        var content = {
                          firstName,
                          lastName,
                          email,
                          subject,
                          occupation,
                          message,
                          terms: termsCheck,
                        };
                        sendMessage(content);
                      }

                      //Check input Validation
                      //Send Form
                      // setShowTerms(true);
                    }}
                  />
                )}
              </Row>
            </>
          ) : (
            <>
              <Row className={Styles.CardHeader}>
                <Col style={{ padding: "0px" }}>
                  <h1  className={Styles.HeaderText}>Terms and Conditions & Privacy Policy</h1>{" "}
                  <div className={Styles.Divider}></div>
                </Col>
              </Row>
              <Row className={Styles.TermsText}>
                <Row>
                  {" "}
                  <LegalSegment
                    label="Terms and Conditions"
                    time="01 October 2021"
                  >
                    <p>Welcome to Matamando Kalilani!</p>

                    <p>
                      These terms and conditions outline the rules and
                      regulations for the use of Matamando Kalilani's Website,
                      located at https://mata.codes/.
                    </p>

                    <p>
                      By accessing this website we assume you accept these terms
                      and conditions. Do not continue to use Matamando Kalilani
                      if you do not agree to take all of the terms and
                      conditions stated on this page.
                    </p>

                    <p>
                      The following terminology applies to these Terms and
                      Conditions, Privacy Statement and Disclaimer Notice and
                      all Agreements: "Client", "You" and "Your" refers to you,
                      the person log on this website and compliant to the
                      Company’s terms and conditions. "The Company",
                      "Ourselves", "We", "Our" and "Us", refers to our Company.
                      "Party", "Parties", or "Us", refers to both the Client and
                      ourselves. All terms refer to the offer, acceptance and
                      consideration of payment necessary to undertake the
                      process of our assistance to the Client in the most
                      appropriate manner for the express purpose of meeting the
                      Client’s needs in respect of provision of the Company’s
                      stated services, in accordance with and subject to,
                      prevailing law of Netherlands. Any use of the above
                      terminology or other words in the singular, plural,
                      capitalization and/or he/she or they, are taken as
                      interchangeable and therefore as referring to same.
                    </p>

                    <h3>
                      <strong>Cookies</strong>
                    </h3>

                    <p>
                      We employ the use of cookies. By accessing Matamando
                      Kalilani, you agreed to use cookies in agreement with the
                      Matamando Kalilani's Privacy Policy.{" "}
                    </p>

                    <p>
                      Most interactive websites use cookies to let us retrieve
                      the user’s details for each visit. Cookies are used by our
                      website to enable the functionality of certain areas to
                      make it easier for people visiting our website. Some of
                      our affiliate/advertising partners may also use cookies.
                    </p>

                    <h3>
                      <strong>License</strong>
                    </h3>

                    <p>
                      Unless otherwise stated, Matamando Kalilani and/or its
                      licensors own the intellectual property rights for all
                      material on Matamando Kalilani. All intellectual property
                      rights are reserved. You may access this from Matamando
                      Kalilani for your own personal use subjected to
                      restrictions set in these terms and conditions.
                    </p>

                    <p>You must not:</p>
                    <ul>
                      <li>Republish material from Matamando Kalilani</li>
                      <li>
                        Sell, rent or sub-license material from Matamando
                        Kalilani
                      </li>
                      <li>
                        Reproduce, duplicate or copy material from Matamando
                        Kalilani
                      </li>
                      <li>Redistribute content from Matamando Kalilani</li>
                    </ul>

                    <p>
                      This Agreement shall begin on the date hereof. Our Terms
                      and Conditions were created with the help of the{" "}
                      <a href="https://www.termsandconditionsgenerator.com">
                        Terms And Conditions Generator
                      </a>
                      .
                    </p>

                    <p>
                      Parts of this website offer an opportunity for users to
                      post and exchange opinions and information in certain
                      areas of the website. Matamando Kalilani does not filter,
                      edit, publish or review Comments prior to their presence
                      on the website. Comments do not reflect the views and
                      opinions of Matamando Kalilani,its agents and/or
                      affiliates. Comments reflect the views and opinions of the
                      person who post their views and opinions. To the extent
                      permitted by applicable laws, Matamando Kalilani shall not
                      be liable for the Comments or for any liability, damages
                      or expenses caused and/or suffered as a result of any use
                      of and/or posting of and/or appearance of the Comments on
                      this website.
                    </p>

                    <p>
                      Matamando Kalilani reserves the right to monitor all
                      Comments and to remove any Comments which can be
                      considered inappropriate, offensive or causes breach of
                      these Terms and Conditions.
                    </p>

                    <p>You warrant and represent that:</p>

                    <ul>
                      <li>
                        You are entitled to post the Comments on our website and
                        have all necessary licenses and consents to do so;
                      </li>
                      <li>
                        The Comments do not invade any intellectual property
                        right, including without limitation copyright, patent or
                        trademark of any third party;
                      </li>
                      <li>
                        The Comments do not contain any defamatory, libelous,
                        offensive, indecent or otherwise unlawful material which
                        is an invasion of privacy
                      </li>
                      <li>
                        The Comments will not be used to solicit or promote
                        business or custom or present commercial activities or
                        unlawful activity.
                      </li>
                    </ul>

                    <p>
                      You hereby grant Matamando Kalilani a non-exclusive
                      license to use, reproduce, edit and authorize others to
                      use, reproduce and edit any of your Comments in any and
                      all forms, formats or media.
                    </p>

                    <h3>
                      <strong>Hyperlinking to our Content</strong>
                    </h3>

                    <p>
                      The following organizations may link to our Website
                      without prior written approval:
                    </p>

                    <ul>
                      <li>Government agencies;</li>
                      <li>Search engines;</li>
                      <li>News organizations;</li>
                      <li>
                        Online directory distributors may link to our Website in
                        the same manner as they hyperlink to the Websites of
                        other listed businesses; and
                      </li>
                      <li>
                        System wide Accredited Businesses except soliciting
                        non-profit organizations, charity shopping malls, and
                        charity fundraising groups which may not hyperlink to
                        our Web site.
                      </li>
                    </ul>

                    <p>
                      These organizations may link to our home page, to
                      publications or to other Website information so long as
                      the link: (a) is not in any way deceptive; (b) does not
                      falsely imply sponsorship, endorsement or approval of the
                      linking party and its products and/or services; and (c)
                      fits within the context of the linking party’s site.
                    </p>

                    <p>
                      We may consider and approve other link requests from the
                      following types of organizations:
                    </p>

                    <ul>
                      <li>
                        commonly-known consumer and/or business information
                        sources;
                      </li>
                      <li>dot.com community sites;</li>
                      <li>
                        associations or other groups representing charities;
                      </li>
                      <li>online directory distributors;</li>
                      <li>internet portals;</li>
                      <li>accounting, law and consulting firms; and</li>
                      <li>educational institutions and trade associations.</li>
                    </ul>

                    <p>
                      We will approve link requests from these organizations if
                      we decide that: (a) the link would not make us look
                      unfavorably to ourselves or to our accredited businesses;
                      (b) the organization does not have any negative records
                      with us; (c) the benefit to us from the visibility of the
                      hyperlink compensates the absence of Matamando Kalilani;
                      and (d) the link is in the context of general resource
                      information.
                    </p>

                    <p>
                      These organizations may link to our home page so long as
                      the link: (a) is not in any way deceptive; (b) does not
                      falsely imply sponsorship, endorsement or approval of the
                      linking party and its products or services; and (c) fits
                      within the context of the linking party’s site.
                    </p>

                    <p>
                      If you are one of the organizations listed in paragraph 2
                      above and are interested in linking to our website, you
                      must inform us by sending an e-mail to Matamando Kalilani.
                      Please include your name, your organization name, contact
                      information as well as the URL of your site, a list of any
                      URLs from which you intend to link to our Website, and a
                      list of the URLs on our site to which you would like to
                      link. Wait 2-3 weeks for a response.
                    </p>

                    <p>
                      Approved organizations may hyperlink to our Website as
                      follows:
                    </p>

                    <ul>
                      <li>By use of our corporate name; or</li>
                      <li>
                        By use of the uniform resource locator being linked to;
                        or
                      </li>
                      <li>
                        By use of any other description of our Website being
                        linked to that makes sense within the context and format
                        of content on the linking party’s site.
                      </li>
                    </ul>

                    <p>
                      No use of Matamando Kalilani's logo or other artwork will
                      be allowed for linking absent a trademark license
                      agreement.
                    </p>

                    <h3>
                      <strong>iFrames</strong>
                    </h3>

                    <p>
                      Without prior approval and written permission, you may not
                      create frames around our Webpages that alter in any way
                      the visual presentation or appearance of our Website.
                    </p>

                    <h3>
                      <strong>Content Liability</strong>
                    </h3>

                    <p>
                      We shall not be hold responsible for any content that
                      appears on your Website. You agree to protect and defend
                      us against all claims that is rising on your Website. No
                      link(s) should appear on any Website that may be
                      interpreted as libelous, obscene or criminal, or which
                      infringes, otherwise violates, or advocates the
                      infringement or other violation of, any third party
                      rights.
                    </p>

                    <h3>
                      <strong>Your Privacy</strong>
                    </h3>

                    <p>Please read Privacy Policy</p>

                    <h3>
                      <strong>Reservation of Rights</strong>
                    </h3>

                    <p>
                      We reserve the right to request that you remove all links
                      or any particular link to our Website. You approve to
                      immediately remove all links to our Website upon request.
                      We also reserve the right to amen these terms and
                      conditions and it’s linking policy at any time. By
                      continuously linking to our Website, you agree to be bound
                      to and follow these linking terms and conditions.
                    </p>

                    <h3>
                      <strong>Removal of links from our website</strong>
                    </h3>

                    <p>
                      If you find any link on our Website that is offensive for
                      any reason, you are free to contact and inform us any
                      moment. We will consider requests to remove links but we
                      are not obligated to or so or to respond to you directly.
                    </p>

                    <p>
                      We do not ensure that the information on this website is
                      correct, we do not warrant its completeness or accuracy;
                      nor do we promise to ensure that the website remains
                      available or that the material on the website is kept up
                      to date.
                    </p>

                    <h3>
                      <strong>Disclaimer</strong>
                    </h3>

                    <p>
                      To the maximum extent permitted by applicable law, we
                      exclude all representations, warranties and conditions
                      relating to our website and the use of this website.
                      Nothing in this disclaimer will:
                    </p>

                    <ul>
                      <li>
                        limit or exclude our or your liability for death or
                        personal injury;
                      </li>
                      <li>
                        limit or exclude our or your liability for fraud or
                        fraudulent misrepresentation;
                      </li>
                      <li>
                        limit any of our or your liabilities in any way that is
                        not permitted under applicable law; or
                      </li>
                      <li>
                        exclude any of our or your liabilities that may not be
                        excluded under applicable law.
                      </li>
                    </ul>

                    <p>
                      The limitations and prohibitions of liability set in this
                      Section and elsewhere in this disclaimer: (a) are subject
                      to the preceding paragraph; and (b) govern all liabilities
                      arising under the disclaimer, including liabilities
                      arising in contract, in tort and for breach of statutory
                      duty.
                    </p>

                    <p>
                      As long as the website and the information and services on
                      the website are provided free of charge, we will not be
                      liable for any loss or damage of any nature.
                    </p>
                  </LegalSegment>
                </Row>
                <Row>
                  {" "}
                  <LegalSegment
                    label="Privacy Policy for Matamando Kalilani"
                    time="01 October 2021"
                  >
                    {/* <h1>Privacy Policy for Matamando Kalilani</h1> */}

                    <p>
                      At Matamando Kalilani, accessible from
                      https://mata.codes/, one of our main priorities is the
                      privacy of our visitors. This Privacy Policy document
                      contains types of information that is collected and
                      recorded by Matamando Kalilani and how we use it.
                    </p>

                    <p>
                      If you have additional questions or require more
                      information about our Privacy Policy, do not hesitate to
                      contact us.
                    </p>

                    <p>
                      This Privacy Policy applies only to our online activities
                      and is valid for visitors to our website with regards to
                      the information that they shared and/or collect in
                      Matamando Kalilani. This policy is not applicable to any
                      information collected offline or via channels other than
                      this website. Our Privacy Policy was created with the help
                      of the{" "}
                      <a href="https://www.privacypolicygenerator.info">
                        Free Privacy Policy Generator
                      </a>
                      .
                    </p>

                    <h2>Consent</h2>

                    <p>
                      By using our website, you hereby consent to our Privacy
                      Policy and agree to its terms.
                    </p>

                    <h2>Information we collect</h2>

                    <p>
                      The personal information that you are asked to provide,
                      and the reasons why you are asked to provide it, will be
                      made clear to you at the point we ask you to provide your
                      personal information.
                    </p>
                    <p>
                      If you contact us directly, we may receive additional
                      information about you such as your name, email address,
                      phone number, the contents of the message and/or
                      attachments you may send us, and any other information you
                      may choose to provide.
                    </p>
                    <p>
                      When you register for an Account, we may ask for your
                      contact information, including items such as name, company
                      name, address, email address, and telephone number.
                    </p>

                    <h2>How we use your information</h2>

                    <p>
                      We use the information we collect in various ways,
                      including to:
                    </p>

                    <ul>
                      <li>Provide, operate, and maintain our website</li>
                      <li>Improve, personalize, and expand our website</li>
                      <li>Understand and analyze how you use our website</li>
                      <li>
                        Develop new products, services, features, and
                        functionality
                      </li>
                      <li>
                        Communicate with you, either directly or through one of
                        our partners, including for customer service, to provide
                        you with updates and other information relating to the
                        website, and for marketing and promotional purposes
                      </li>
                      <li>Send you emails</li>
                      <li>Find and prevent fraud</li>
                    </ul>

                    <h2>Log Files</h2>

                    <p>
                      Matamando Kalilani follows a standard procedure of using
                      log files. These files log visitors when they visit
                      websites. All hosting companies do this and a part of
                      hosting services' analytics. The information collected by
                      log files include internet protocol (IP) addresses,
                      browser type, Internet Service Provider (ISP), date and
                      time stamp, referring/exit pages, and possibly the number
                      of clicks. These are not linked to any information that is
                      personally identifiable. The purpose of the information is
                      for analyzing trends, administering the site, tracking
                      users' movement on the website, and gathering demographic
                      information.
                    </p>

                    <h2>Advertising Partners Privacy Policies</h2>

                    <p>
                      You may consult this list to find the Privacy Policy for
                      each of the advertising partners of Matamando Kalilani.
                    </p>

                    <p>
                      Third-party ad servers or ad networks uses technologies
                      like cookies, JavaScript, or Web Beacons that are used in
                      their respective advertisements and links that appear on
                      Matamando Kalilani, which are sent directly to users'
                      browser. They automatically receive your IP address when
                      this occurs. These technologies are used to measure the
                      effectiveness of their advertising campaigns and/or to
                      personalize the advertising content that you see on
                      websites that you visit.
                    </p>

                    <p>
                      Note that Matamando Kalilani has no access to or control
                      over these cookies that are used by third-party
                      advertisers.
                    </p>

                    <h2>Third Party Privacy Policies</h2>

                    <p>
                      Matamando Kalilani's Privacy Policy does not apply to
                      other advertisers or websites. Thus, we are advising you
                      to consult the respective Privacy Policies of these
                      third-party ad servers for more detailed information. It
                      may include their practices and instructions about how to
                      opt-out of certain options.{" "}
                    </p>

                    <p>
                      You can choose to disable cookies through your individual
                      browser options. To know more detailed information about
                      cookie management with specific web browsers, it can be
                      found at the browsers' respective websites.
                    </p>

                    <h2>
                      CCPA Privacy Rights (Do Not Sell My Personal Information)
                    </h2>

                    <p>
                      Under the CCPA, among other rights, California consumers
                      have the right to:
                    </p>
                    <p>
                      Request that a business that collects a consumer's
                      personal data disclose the categories and specific pieces
                      of personal data that a business has collected about
                      consumers.
                    </p>
                    <p>
                      Request that a business delete any personal data about the
                      consumer that a business has collected.
                    </p>
                    <p>
                      Request that a business that sells a consumer's personal
                      data, not sell the consumer's personal data.
                    </p>
                    <p>
                      If you make a request, we have one month to respond to
                      you. If you would like to exercise any of these rights,
                      please contact us.
                    </p>

                    <h2>GDPR Data Protection Rights</h2>

                    <p>
                      We would like to make sure you are fully aware of all of
                      your data protection rights. Every user is entitled to the
                      following:
                    </p>
                    <p>
                      The right to access – You have the right to request copies
                      of your personal data. We may charge you a small fee for
                      this service.
                    </p>
                    <p>
                      The right to rectification – You have the right to request
                      that we correct any information you believe is inaccurate.
                      You also have the right to request that we complete the
                      information you believe is incomplete.
                    </p>
                    <p>
                      The right to erasure – You have the right to request that
                      we erase your personal data, under certain conditions.
                    </p>
                    <p>
                      The right to restrict processing – You have the right to
                      request that we restrict the processing of your personal
                      data, under certain conditions.
                    </p>
                    <p>
                      The right to object to processing – You have the right to
                      object to our processing of your personal data, under
                      certain conditions.
                    </p>
                    <p>
                      The right to data portability – You have the right to
                      request that we transfer the data that we have collected
                      to another organization, or directly to you, under certain
                      conditions.
                    </p>
                    <p>
                      If you make a request, we have one month to respond to
                      you. If you would like to exercise any of these rights,
                      please contact us.
                    </p>

                    <h2>Children's Information</h2>

                    <p>
                      Another part of our priority is adding protection for
                      children while using the internet. We encourage parents
                      and guardians to observe, participate in, and/or monitor
                      and guide their online activity.
                    </p>

                    <p>
                      Matamando Kalilani does not knowingly collect any Personal
                      Identifiable Information from children under the age of
                      13. If you think that your child provided this kind of
                      information on our website, we strongly encourage you to
                      contact us immediately and we will do our best efforts to
                      promptly remove such information from our records.
                    </p>
                  </LegalSegment>
                </Row>
              </Row>
              <Row className={Styles.TermsButtonsSection}>
                <ActionButton
                  label="Agree"
                  icon="done"
                  styles={{
                    backgroundColor: "#ECFFF7",
                    borderColor: "#005651",
                    color: "#005651",
                    borderStyle: "solid",
                    borderWidth: "2px",
                    marginLeft: "auto",
                    width: "inherit",
                  }}
                  iconStyles={{
                    fontSize: "20px",
                    marginLeft: "5px",
                    color: "#005651",
                  }}
                  onClick={async () => {
                    //Tick Tick Box for Terms
                    setTermsCheck(true);
                    var checkTermsResult = await validateTermsCheck(true);
                    setTermsCheckError(checkTermsResult);
                    setShowTerms(false);
                  }}
                />
                <ActionButton
                  label="Decline"
                  icon="close"
                  styles={{
                    backgroundColor: "#FFEFEF",
                    borderColor: "#C70125",
                    color: "#C70125",
                    borderStyle: "solid",
                    borderWidth: "2px",
                    marginLeft: "20px",
                    width: "inherit",
                  }}
                  iconStyles={{
                    fontSize: "20px",
                    marginLeft: "5px",
                    color: "#C70125",
                  }}
                  onClick={async () => {
                    //Untick Tick Box for Terms
                    setTermsCheck(false);
                    var checkTermsResult = await validateTermsCheck(false);
                    setTermsCheckError(checkTermsResult);
                    setShowTerms(false);
                  }}
                />
              </Row>
            </>
          )}
        </div>
      </Popup>
    </>
  );
}

export default ContactMeCard;
